<template>
  <div class="columns">
    <div class="column">
      <BaseInput type="password" v-model="password" label="סיסמא חדשה" />
    </div>
    <div class="column">
      <BaseInput
        type="password"
        v-model="confirmPassword"
        label="אימות סיסמא"
      />
    </div>
    <div class="modal_footer">
      <a @click="submit()" class="button is-info">איפוס</a>
    </div>
  </div>
</template>
<script>
// components
import BaseInput from '@/components/BaseInput.vue'

export default {
  name: 'reset-password',
  props: ['payload'],
  data () {
    return {
      password: '',
      confirmPassword: ''
    }
  },
  methods: {
    async submit () {
      try {
        if (this.password !== this.confirmPassword) return
        const response = await this.$network_utils.resetPassword({
          id: this.payload.id,
          password: this.password
        })
        if (response === 'ok') {
          this.$utils.emit('show_toast', {
            text: 'Password has been reset successfully'
          })
        } else {
          this.$utils.emit('show_toast', {
            text: 'Unable to reset password due to an unknown error. Please try again.'
          })
        }
      } catch (e) {
        this.$utils.emit('show_toast', {
          text: 'Unable to reset password due to an unknown error. Please try again.'
        })
        console.error(e)
      }
    }
  },
  components: {
    BaseInput
  }
}
</script>
